export default {
  filters: 'Filtres:',
  btnReset: 'Réinitialisation',
  price: 'Prix',
  privateTransfer: 'Course privée',
  wheelchar: 'Fauteuil roulant',
};